<div class="w3-display-container w3-theme-primary auth-screen">
  <div class="w3-display-topmiddle w3-padding-48">
    <img [src]="logo" height="41px" [alt]="appName" />
  </div>
  <div class="w3-display-middle">
    <section class="w3-content password-form">
      <form novalidate (submit)="changePassword($event)">
        <header class="w3-container">
          <h2 class="w3-xlarge">Change Password</h2>
        </header>
        <section
          class="w3-container w3-margin-bottom w3-margin-left w3-border-theme-secondary w3-bottombar half-line"
        ></section>
        <section class="w3-container">
          <label for="change-old-password"><b>Current password</b></label>
          <input
            id="change-old-password"
            name="current-password"
            autocomplete="current-password"
            class="w3-input w3-border w3-section"
            [class.invalid]="oldPasswordMissing"
            [attr.aria-invalid]="oldPasswordMissing"
            type="password"
            [value]="oldPassword"
            (input)="oldPassword = $any($event.target).value"
          />

          <label for="change-new-password"><b>New password</b></label>
          <input
            id="change-new-password"
            name="new-password"
            autocomplete="new-password"
            class="w3-input w3-border w3-section"
            [class.invalid]="newPasswordInvalid"
            [attr.aria-invalid]="newPasswordInvalid"
            aria-describedby="change-password-rules"
            type="password"
            [value]="newPassword"
            (input)="newPassword = $any($event.target).value"
          />
          <ul id="change-password-rules" class="rules" aria-live="polite">
            @for (rule of rules; track rule.id) {
              <li
                [class.met]="rule.test(newPassword)"
                [attr.data-rule]="rule.id"
              >
                <i
                  class="fa-solid"
                  [class.fa-check]="rule.test(newPassword)"
                  [class.fa-circle]="!rule.test(newPassword)"
                  aria-hidden="true"
                ></i>
                {{ rule.label }}
                <span class="sr-only">{{
                  rule.test(newPassword) ? '(met)' : '(not met)'
                }}</span>
              </li>
            }
            @if (!differsFromOld) {
              <li class="problem" data-rule="differs">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                Different from the current password
              </li>
            }
          </ul>

          <label for="change-verify-password"><b>Repeat new password</b></label>
          <input
            id="change-verify-password"
            name="verify-password"
            autocomplete="new-password"
            class="w3-input w3-border w3-section"
            [class.invalid]="verifyInvalid"
            [attr.aria-invalid]="verifyInvalid"
            type="password"
            [value]="verifyPassword"
            (input)="verifyPassword = $any($event.target).value"
          />
          @if (verifyInvalid) {
            <p class="field-error" data-error="verify">
              The passwords do not match.
            </p>
          }
          @if (oldPasswordMissing) {
            <p class="field-error" data-error="old">
              Enter your current password.
            </p>
          }
          @if (error) {
            <p class="form-error" role="alert" data-error="cognito">
              {{ error }}
            </p>
          }
        </section>

        <footer class="w3-container">
          <button
            type="submit"
            class="w3-btn w3-block w3-white w3-section text-bold"
            [disabled]="busy"
          >
            Change Password
          </button>
          <button
            type="button"
            class="w3-btn w3-block w3-white w3-section text-bold secondary"
            (click)="cancel()"
          >
            Cancel
          </button>
        </footer>
      </form>
    </section>
  </div>
</div>
